type Callback = (...args: any[]) => any | Promise<any>;

interface EventFace {
    on: (name: string, callback: Callback) => void,
    emit: (name: string, ...args: Array<any>) => void,
    off: (name: string, fn: Callback) => void,
    once: (name: string, fn: Callback) => void
}

interface List {
    [key: string]: Array<Callback>;
}

// 区分下页面

export class DispatchEvent implements EventFace {
    private list: List;
    constructor() {
        this.list = {};
    }
    private getName(name: string) {
        return `${name}`;
    }
    on(name: string, callback: Callback) {
        const callbackList: Array<Callback> = this.list[this.getName(name)] || [];
        callbackList.push(callback);
        this.list[this.getName(name)] = callbackList;
    }
    emit(name: string, ...args: Array<any>) {
        const evnetName = this.list[this.getName(name)];
        if (evnetName) {
            evnetName.forEach(fn => {
                fn.apply(this, args);
            });
        } else {
            console.error(`事件${this.getName(name)}未监听`);
        }
    }
    clear() {
        this.list = {};
    }
    off(name: string, fn: Callback) {
        const callbackList: Array<Callback> = this.list[this.getName(name)] || [];
        this.list[this.getName(name)] = callbackList.filter(fns => fns !== fn);
    }
    once(name: string, fn: Callback) {
        const decor = (...args: Array<any>) => {
            fn.apply(this, args);
            this.off(this.getName(name), decor);
        };
        this.on(this.getName(name), decor);
    }
}
